import React from "react";
import {useState} from "react";



const Slide = () => {
  return (
    <div>
<div className="slider">
    <div className="sliderWrapper">
        <div className="sliderItem">
            <img src="https://i.pinimg.com/564x/fd/0a/9b/fd0a9bf83c7e42f76da251b828da41eb.jpg"  className="sliderImg"/>
            <div className="sliderBg"></div>
        </div>
        <div className="sliderItem">
            <img src="https://i.pinimg.com/564x/fd/0a/9b/fd0a9bf83c7e42f76da251b828da41eb.jpg"  className="sliderImg"/>
            <div className="sliderBg"></div>
        </div>

        <div className="sliderItem">
            <img src  className="sliderImg"/>
            <div className="sliderBg"></div>
        </div>
        
    </div>
</div>
</div>
     
  );
};

export default Slide